<template>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group search-wrapper">
          <label for="code" class="floatings text-uppercase">{{ reason }}
            <input type="text" class="form-control" id="code" name="code" v-model="code" @change="triggerInputFunction(code)" />
            <span class="close" @click="code=''"></span>
          </label>
          <span id="code-value" class="hidden">{{ code }}</span>
          <div class="invalid-feedback" v-if="errors">
            <span v-for="item in errors">{{ item }} </span><br>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden" id="searchResult">{{ searchResult}}</div>
    <div class="hidden" id="stateMessage">{{ stateMessage}}</div>
  </div>

</template>

<script>
export default {
  name: "BooksInAcquisitionBatch",
  props: ['acquisition_batch_id', 'library_id'],
  data(){
    return {
      errors: {},
      code: '',
      searchResult: '',
      stateMessage: '',
      reason: '',
      book: {
        id: '',
        title: '',
        author: '',
        invent_number: '',
        code: '',
        price: '',
        added_to_acquisition_batch: '',
      },

    }
  },
  mounted() {
    if(window.location.pathname === '/library/acquisition-batches') {
      this.reason = 'Введіть або відскануйте штрихкод щоб знайти книгу';
    } else if (
        window.location.pathname.indexOf("/library/acquisition-batches/") !== -1
    ) {
      this.reason = 'Введіть або відскануйте штрихкод щоб додати книгу';
    } else {

    }
  },
  methods:{
    triggerInputFunction(book) {
      if(parseInt(this.$props.acquisition_batch_id)) {
        this.addBook(book);
      } else {
        this.searchABContainingBook(book);
      }
    },
    addBook(code) {
      this.errors = [];
      this.searchResult = '';
      if (!code) {
        return;
      }
      this.stateMessage = '';

      axios.put('/library/acquisition-batches/' + this.$props.acquisition_batch_id + '/addBook', {
        library_id: this.$props.library_id,
        code: code,
      }).then(response => {
        if ('string' === typeof(response.data.data)) {
          this.errors.push(response.data.data);
          return;
        }
        this.searchResult = response.data.data;
        this.stateMessage = response.data.stateMessage;
      }).catch(error => {
        this.errors = error.response.data.errors;
        console.log('Errors:');
        console.log(error.response.data.errors);
      });

    },

    searchABContainingBook(code) {
      this.errors = [];
      this.searchResult = '';
      if (!code) {
        return;
      }
      axios.get('acquisition-batches-whereIsBook/?library_id=' + this.$props.library_id + '&code=' + code).then(response => {
        if (!response.data.data) {
          this.errors.push('Книга не додана у жодну партію');
          return;
        } else {
          this.searchResult = response.data.data;
        }
      }).catch(error => {
        this.errors = error.response.data.errors;
        console.log('Errors:');
        console.log(error.response.data.errors);
      });
    }

  },
}
</script>

<style scoped>
.invalid-feedback {
  display: block;
}

.invalid-feedback span {
  display: block;
}

.search-wrapper label {
  position: relative;
  width: 100%;
}

.close {
  position: absolute;
  top: 60%;
  right: 20px;
  width: 8px;
  height: 8px;
  opacity: 0.3;
  cursor: pointer;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 4px;
  content: ' ';
  height: 12px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
</style>